import React from 'react';
import { useHistory } from 'react-router-dom';

import { PageLayout } from '@/components/templates/PageLayout';
import {
  CmBox,
  CmCard,
  CmLongLoading,
  CmStack,
  CmText,
} from '@/components/uiParts';
import {
  canUseMosPosResendPage,
  redirect404MosPosResendPage,
} from '@/lib/AccessControl';
import { MosPosOrderTable } from '@/pages/externals/mos-pos-resend/index/components/MosPosOrderTable';
import { PageNumberPagination } from '@/pages/externals/mos-pos-resend/index/components/PageNumberPagination';
import { SearchFilter } from '@/pages/externals/mos-pos-resend/index/components/SearchFilter';
import { useMosPosResendListPage } from '@/pages/externals/mos-pos-resend/index/useMosPosResendListPage';
import { ITEMS_PER_PAGE } from '@/pages/externals/mos-pos-resend/service';
import { routes } from '@/router';
import { useManagerAccountMe } from '@/services/AuthEnterprise/hooks';

const MosPosResendListPage: React.VFC = () => {
  /* アクセス制御 */
  const history = useHistory();
  const { managerAccountMe } = useManagerAccountMe();
  redirect404MosPosResendPage(history, managerAccountMe);

  const {
    form,
    page,
    items,
    total,
    stores,
    isLoadingStores,
    hasStoreError,
    isLoading,
    isFetching,
    hasError,
    handlers,
  } = useMosPosResendListPage(canUseMosPosResendPage(managerAccountMe));

  return (
    <PageLayout title={routes.MosPosResendList.title}>
      <CmStack spacing={3} my={5} data-testid="mos-pos-resend-content">
        {/* 検索条件エリア (No.2〜5) は一覧とは別カード */}
        <CmCard mb="16px">
          <SearchFilter
            form={form}
            stores={stores}
            isLoadingStores={isLoadingStores}
            hasStoreError={hasStoreError}
            isSearching={isFetching}
            onChangeAuthStoreId={handlers.handleChangeAuthStoreId}
            onChangeDeliveryServiceId={handlers.handleChangeDeliveryServiceId}
            onChangeOrderDateStart={handlers.handleChangeOrderDateStart}
            onChangeOrderDateEnd={handlers.handleChangeOrderDateEnd}
            onSearch={handlers.handleSearch}
          />
        </CmCard>

        <CmCard>
          {isLoading ? (
            <CmLongLoading />
          ) : hasError ? (
            // エラーはトーストで通知するため、ここには何も表示しない
            <></>
          ) : items.length === 0 ? (
            // No.18 空状態: 一覧エリアの中央にテキストのみ
            <CmText textAlign="center" color="gray.500" padding="60px 0">
              該当する注文はありません。
            </CmText>
          ) : (
            <>
              {/* No.6 / No.7 は一覧の上 (テンプレートの .table-toolbar) */}
              <CmBox mb="12px">
                <PageNumberPagination
                  currentPage={page}
                  itemsPerPage={ITEMS_PER_PAGE}
                  totalItems={total}
                  onPageChange={handlers.handlePageChange}
                />
              </CmBox>
              <CmBox overflowX="auto">
                <MosPosOrderTable
                  items={items}
                  onRowClick={handlers.handleRowClick}
                  onResendClick={handlers.handleResendClick}
                  onCancelClick={handlers.handleCancelClick}
                />
              </CmBox>
            </>
          )}
        </CmCard>
      </CmStack>
    </PageLayout>
  );
};

export default MosPosResendListPage;
